<template>
  <div class="app-container">
    <list ref="list">
    
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from '@/components/production/clothmanagement/clothprogress/list'
// import editDialog from '@/components/production/clothmanagement/cloth/editDialog'

export default {
  name: "clothprogress",
  mixins: [curdMixins],
  components: {
    list,
    // editDialog
  },
  methods: {
    delRows(){

    },
    
  }
  
};
</script>